import { waitForElementToExist } from './waitForElement';

/* eslint-disable */

export const orderDetailPage = () => {
	const pageStyle = ({ page }) => {
		const main = page.closest('#primary')
		if (!main) return

		page.querySelector('.c7-account-order-detail') && (page.querySelector('.c7-account-order-detail').style = 'padding: 0;');

		const sectionContainer = main.querySelector('.mx-auto')
		if (!sectionContainer) return
		sectionContainer.classList = 'w-full bg-[#f0efe7]';

		const wrapper = sectionContainer.querySelector('.c7-wrapper')
		if (!wrapper) return
		wrapper.classList = 'w-full';

		const banner = page.querySelector('.c7-receipt__header')
		if (!banner) return
		banner.classList += ' bg-[#473D21] pt-16 pb-32 px-8 text-center text-primary relative overflow-hidden mb-0';

		import('./../components/textureResume').then(({ textureResume }) => {
			banner.insertAdjacentHTML('beforeend', `<div class="z-10 absolute bottom-0 w-full inset-x-0 translate-y-1 -translate-x-1">
			${textureResume({ props: 'style="width: 102%; height: auto"' })}
			</div>`)

			const bgImage = document.createElement('img')
			/* image background */
			bgImage.src = template.texture_default;
			bgImage.classList = 'absolute inset-0 object-cover object-top w-full h-full mix-blend-multiply opacity-50'
			banner.appendChild(bgImage)
		})


		const button = banner.querySelector('.c7-btn')
		button && (button.classList = 'button button-outline text-primary mx-auto mt-6 relative z-10');
		button && (button.style = 'color: var(--primary-color);')

		const title = banner.querySelector('h1')
		if (title) {
			title.classList = 'text-2xl xl:text-4xl font-semibold headlines-font uppercase mb-6 text-primary text-center';
			title.insertAdjacentHTML('beforebegin', `<span class="mx-auto inline-block bg-primary p-4 mb-6 rounded-full">
			<svg class="mx-auto" xmlns="http://www.w3.org/2000/svg" width="32.303" height="32.302" viewBox="0 0 32.303 32.302" style="width: 2rem; height: 2rem; stroke: none; stroke-width: 0;">
			<path id="Union_12" data-name="Union 12" d="M0,16.152A16.159,16.159,0,0,1,21.6.945a1.384,1.384,0,0,1-.933,2.606,13.384,13.384,0,1,0,8.867,12.6,1.384,1.384,0,0,1,2.768,0,16.151,16.151,0,1,1-32.3,0Zm15.172,4.672L9.635,15.287a1.385,1.385,0,1,1,1.958-1.958l4.557,4.559L29.939,4.1A1.385,1.385,0,0,1,31.9,6.058L17.131,20.824a1.388,1.388,0,0,1-1.958,0Z" transform="translate(0 -0.002)" fill="#d8a64b"/>
			</svg>
			</span>`)
		}

		const sectionDetail = page.querySelector('.c7-account-order-detail__content')
		sectionDetail && (sectionDetail.classList = 'order-receipt w-11/12 mx-auto max-w-8xl flex flex-wrap gap-5 lg:gap-0 justify-center');

		const callOut = sectionDetail.querySelector('.c7-callout')
		callOut && import('./../components/iconHelp').then(({ iconHelp }) => {
			callOut.insertAdjacentHTML('afterbegin', iconHelp({ props: 'style="width: auto; height: auto; stroke: none; stroke-width: 0;"' }))
		})
	}
	const orderSummaryStyle = ({ page }) => {
		const orderSummary = page.querySelector('.c7-order-contents')
		if (!orderSummary) return;

		const orderItems = orderSummary.querySelector('.c7-order-items');
		orderItems && (orderItems.classList += ' grid grid-cols-1 gap-4 [&_ul>li]:px-6');
		const itemsTitle = orderItems.querySelectorAll('.c7-order-item__title')
		itemsTitle && itemsTitle.forEach(title => {
			title.classList += ' text-base font-bold text-brown uppercase headlines-font';
		})
		const itemsDescription = orderItems.querySelectorAll('.c7-order-item__description')
		itemsDescription && itemsDescription.forEach(description => {
			description.classList += ' text-sm text-brown uppercase font-bold';
		})
		const itemsPricing = orderItems.querySelectorAll('.c7-order-item__pricing')
		itemsPricing && itemsPricing.forEach(pricing => {
			pricing.classList += ' text-base text-brown uppercase font-bold monospace-font';
			pricing.style = '--c7-font-size-sub: 1rem';
			pricing.querySelector('.c7-order-item__total') && (pricing.querySelector('.c7-order-item__total').classList += ' text-xl');
		})
	}

	waitForElementToExist({ selector: '#c7-content .c7-account-order-detail .c7-receipt__header' }).then(() => {
		const c7Content = document.querySelector('#c7-content')
		c7Content.style = 'padding: 0;'
		pageStyle({ page: c7Content })
		orderSummaryStyle({ page: c7Content })
	})

	waitForElementToExist({ selector: '#c7-content .c7-confirmation--club .c7-receipt__header' }).then(() => {
		const c7Content = document.querySelector('#c7-content')
		c7Content.style = 'padding: 0;'
		pageStyle({ page: c7Content })
		orderSummaryStyle({ page: c7Content });

		const message = c7Content.querySelector('.c7-message')
		message && (message.style = '--c7-link-color: var(--yellow);');
		message && (message.classList = 'justify-center text-base font-semibold flex items-center gap-2');
		
		const clubShipments = c7Content.querySelector('.c7-receipt__club-shipment')
		clubShipments && (clubShipments.style = '--c7-block-bg: var(--primary-color);');
		clubShipments && (clubShipments.classList = 'w-11/12 mx-auto max-w-8xl');
		const clubShipmentsInner = clubShipments.querySelector('.c7-account-club__shipment')
		clubShipmentsInner && (clubShipmentsInner.classList = 'bg-primary');
		const priceTotal = clubShipments.querySelector('.c7-order-summary__value')
		priceTotal && (priceTotal.classList = 'text-2xl flex gap-2 font-bold monospace-font');
	})
}
